function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolWindowLevelCustom = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 333.333,
  height: 333.333,
  style: {
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  },
  viewBox: "0 0 250 250",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M113.5 7.5q60.912-3.192 87.5 51 19.892 56.061-22.5 97.5-40.48 31.875-89 14-43.383-19.394-50.5-66.5Q34.653 37.416 95.5 12a312 312 0 0 1 18-4.5m1 13q33.657-2.785 58 20-50 51-101 101-29.697-32.727-15.5-75 16.834-39.114 58.5-46",
  style: {
    opacity: 0.961
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28.5 197.5h192v44h-192zm96 7h89v30h-89z",
  style: {
    opacity: 0.951
  }
}));
export { SvgToolWindowLevelCustom as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-window-level-custom.svg";